module.exports = __webpack_public_path__ + "components/flag/static/square/cd-55f87611cd3c8a09cc956596c36e3edf.svg";